<div class="navbar-light">
  <div class="row">
    <div class="col-sm-8 col-sm offset-2" *ngIf="getTwoLetterCulture() == 'en'">
      <img src="https://cupe.ca/sites/cupe/themes/cupe_mothership/logo.png" />
    </div>
    <div class="col-sm-8 col-sm offset-2" *ngIf="getTwoLetterCulture() == 'fr'">
      <img src="https://cupe.ca/sites/cupe/themes/cupe_mothership/logo_fr.png" />
    </div>

    <ul class="navbar navbar-nav d-none d-md-flex flex-row">
      <li class="nav-item active" (click)="toggleLanguage()">
        <a class="nav-link language-link" role="button" aria-haspopup="true" aria-expanded="false">
          {{ 'ToggleLanguage' | translate }}
        </a>
      </li>
    </ul>
    <br />
    <br />
    <img alt="" src="./img/cupe-rainbow-email.png" style="width:100%; height: 3px;" />
  </div>

</div>